import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openDataPlatformSubmenu } from '../sidebarHelpers';

const exportSegment = (baseUrl, navigate, segmentEveryone, user) => {
  return {
    id: 'exportSegment',
    title: 'Export segment',
    steps: [
      {
        selector: '[data-tour="dataPlatformLink"]',
        content: <p>Click on the "Data Platform" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openDataPlatformSubmenu('[data-tour="segmentsLink"]'),
        selector: '[data-tour="segmentsLink"]',
        content: <p>Click on the "Segments" in the navigation</p>,
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/segments?searchTerms=${'everyone'}`, true);
        },
        selector: '[data-segment-name="Everyone"]',
        content: <p>This is the "Everyone" segment containing all of your user profiles.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/segments/${segmentEveryone.id}`, true),
        selector: '[data-tour="segmentExportBtn"]',
        content: <p>You can export this segment and receive a download link in your email inbox.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'exportSegment'),
  };
};

export default exportSegment;
